itsoftApp.createModule("scrollActions", ["startLoad"], function () {
    var module = this;
    var registeredPlugin = false;
    var registeredScrollTriggerPlugin = false;
    const getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;

    const libraries = {
        gsap: {
            name: "gsap",
            queue: [],
            started: false,
            loaded: false,
            scriptMore: "/assets/scripts/gsap/ScrollTrigger.min.js",
            script: "/assets/scripts/gsap/gsap.min.js"
        }
    }

    var initScrollActions = function (targetCb, scrollTriggerFlag, cb) { 
        const initScrollExemplar = function () {
            if (!registeredPlugin) {
                registeredPlugin = true;

                if (!registeredScrollTriggerPlugin && scrollTriggerFlag) {
                    gsap.registerPlugin(ScrollTrigger);
                }
            }

            if (cb && typeof cb === "function") {
                cb();
            } else {
                ScrollTrigger.clearScrollMemory();
                var sections = gsap.utils.toArray('.js-scroll-section');
                var items;
                var thisPinWrap;
                var thisAnimWrap;

                sections.forEach(function (sec, i) {	
                    const scrollLine = sec.querySelector(".page__dashed-path");
                    let params;
                    let updateParams;
                    let pathLength;

                    if (scrollLine) {
                        params = itsoftApp.modules.dashAnimation.initCustomAnimation(scrollLine);
                        updateParams = params.updateParams;
                        pathLength = params.pathLength;
                    }

                    items = sec.querySelectorAll('.js-scroll-item');
                    thisPinWrap = sec.querySelector('.js-pin-wrap');
                    thisAnimWrap = thisPinWrap.querySelector('.js-animation-wrap');

                    var getToValue = () => -(thisAnimWrap.clientWidth * (items.length - 1));

                    gsap.fromTo(thisAnimWrap, { 
                        x: 0,
                        }, { 
                        x: getToValue(), 
                        ease: "none",
                        scrollTrigger: {
                            trigger: sec,
                            start: sec.hasAttribute('data-start') ? sec.getAttribute('data-start') : "center center",
                            end: () => "+=" + (thisAnimWrap.clientWidth * ( items.length - 1)),
                            pin: thisPinWrap,
                            invalidateOnRefresh: true,
                            scrub: true,
                            onUpdate: function (self) {
                                if (scrollLine) {
                                    updateParams(pathLength - self.progress * pathLength);
                                }
                            }
                        }
                    });
                });

                targetCb && typeof targetCb === "function" && targetCb();
            }
        }

        new itsoftApp.modules.startLoad.callback(initScrollExemplar, libraries.gsap);
    }

    module.callback = initScrollActions;
});


